import { render, staticRenderFns } from "./ElementAlgorithmTableColumn.vue?vue&type=template&id=0d8a28d4&scoped=true"
import script from "./ElementAlgorithmTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementAlgorithmTableColumn.vue?vue&type=script&lang=js"
import style0 from "./ElementAlgorithmTableColumn.vue?vue&type=style&index=0&id=0d8a28d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8a28d4",
  null
  
)

export default component.exports